// /Carrossier/FormulaireA/utils/validation.js

export const validateForm = (formData) => {
    const errors = {};
    
    // Validation des champs obligatoires
    const requiredFields = [
      { section: 'verificateur', field: 'Nom', label: 'Nom du vérificateur' },
      { section: 'verificateur', field: 'DateVerification', label: 'Date de vérification' },
      { section: 'client', field: 'Nom', label: 'Nom du client' },
      { section: 'vehicule', field: 'Type', label: 'Type de véhicule' },
      { section: 'porte', field: 'NumeroSerie', label: 'Numéro de série' },
    ];
  
    requiredFields.forEach(({ section, field, label }) => {
      if (!formData[section][field]) {
        errors[`${section}.${field}`] = `${label} est obligatoire`;
      }
    });
  
    if (!formData.declarationHonneur) {
      errors.declarationHonneur = "Déclaration sur l'honneur requise";
    }
  
    return errors;
  };